import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { userTokenApi } from './api'

export const userTokenQueries = {
  all: () => ['user-tokens'],
  list: ({ pagination }: { pagination?: Pagination } = {}) => {
    return queryOptions({
      queryKey: [...userTokenQueries.all(), { pagination }],
      queryFn: () => userTokenApi.list({ pagination }),
    })
  },
}
